import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  BehaviorSubject,
  AsyncSubject,
  Observable,
  empty,
  throwError as observableThrowError,
  Subject
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from './error.service';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class UtilService {
  
  bucketName = 'asgeformsstagedev';
  updateNerTrainingData = new Subject<any>()
  updateLeftExcelSheetRow = new Subject<any>()
  updateExcelSheetSelectionExtractionOutput = new Subject<any>();
  constructor(private http: HttpClient) {
   
  }
  storeConfig() {
    const storageConfig: any = localStorage.getItem('storageConfig');
    if(storageConfig){
      this.bucketName = JSON.parse(storageConfig).forms;
    } else {
      this.getStorageConfigs().then((response) => {
        if(response?.forms) {
          this.bucketName = response.forms;
        }
        localStorage.setItem("storageConfig", JSON.stringify(response));
      });
    }
  }
  getStorageConfigs() {
    let url =
      environment.iformWebformAPIUrl +
      "/v1/forms/storage/configs";
    return this.http
      .get(url)
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }
}
